import i18n from '@moovly/i18n';
import { compareAsc, format } from 'date-fns';
import { enUS, nl, fr, es } from 'date-fns/locale';

const locales = {
  en: enUS,
  nl,
  fr,
  es,
};
function isValidDate(d: any) {
  // @ts-ignore
  return d instanceof Date && !isNaN(d);
}
const getDate = (date: Date | string) => {
  if (typeof date === 'string') {
    const formatedDate = new Date(date);
    if (isValidDate(formatedDate)) {
      return new Date(date.replace(' ', 'T'));
    }
    return formatedDate;
  }
  return date;
};
export const formatLocale = (date: Date, formatType: string) => {
  //@ts-ignore
  const locale = locales[i18n.currentLanguage] || locales.en;
  return format(getDate(date), formatType, { locale });
};

export const formatDateForBackend = (date: Date | number) => format(date, 'yyyy-MM-dd HH:mm:ss');

export const formatDate = (date?: Date | string, formatType: string = 'yyyy-MM-dd') => {
  if (!date) {
    return null;
  }
  return formatLocale(getDate(date), formatType);
};
export const formatDateLong = (date: Date | string, formatType: string = 'd MMMM yyyy HH:mm') => {
  if (!date) {
    return null;
  }
  return formatLocale(getDate(date), formatType);
};

export const compareDatesAsc = (dateA: Date | string, dateB: Date | string) => {
  return compareAsc(getDate(dateA), getDate(dateB));
};
